import * as dataActions from '../actions/dataActions'
import * as generalActions from '../actions/generalActions'
import * as receiptActions from '../actions/receiptActions'
import * as modalActions from '../modal/actions/modalActions'
import { setGroup } from '../actions/layoutActions'

import * as rl from '../models/ReceiptLine';

import * as general from '../constants/General'
import * as types from '../constants/Types'
import * as resource from '../constants/Resources'
import * as status from '../constants/Status'
import * as right from '../constants/Rights'
import { hasRight } from '../actions/rightsActions'
import * as systemSetting from '../constants/SystemSettings'

export function startPayment() {
    return async (dispatch, getState) => {
        dispatch(receiptActions.setReceiptLinesDisabledForBlackBox());
        
        let msg = ''

        // Check if receipt is empty for invoicing
        if (getState().receiptState.receipt.shouldinvoice && (!getState().receiptState.receipt.lines || getState().receiptState.receipt.lines.length === 0)) {
            msg = dispatch(dataActions.getTranslation(resource.INVOICE_EMPTY_RECEIPT_MESSAGE));
        }

        // Check if a customer is required before starting payment
        const pos = dispatch(dataActions.getPos(getState().generalState.posId));
        if (msg === '' && pos !== null && pos.CustomerRequired && !(getState().receiptState.receipt.customer.customerid > 0)) {
            msg = dispatch(dataActions.getTranslation(resource.CUSTOMER_REQUIRED_LONG));
        }

        // Check if receiptnumber exists
        if (getState().receiptState.receipt.receiptnumber === null
            || getState().receiptState.receipt.receiptnumber === '') {
            const inputquantitynegative = getState().receiptState.input.inputquantitynegative;
            await dispatch(receiptActions.createReceipt(inputquantitynegative))
        }

        if (msg === '') {
            //Determine paymentmethod 
            if (getState().generalState.paymentMethod.all.length < 1) {
                msg = dispatch(dataActions.getTranslation(resource.NO_PAYMENTMETHODS));
            }
            else if (getState().generalState.paymentMethod.all.length > 1) {
                const itemList = [];
                const disablePaymentsWithInvoice =  getState().generalState.systemSettings[systemSetting.DISABLE_PAYMENTS_WITH_INVOICE];
                getState().generalState.paymentMethod.all.forEach(paymentMethod => {
                    if (disablePaymentsWithInvoice) {
                        if (((paymentMethod.ShouldInvoice || paymentMethod.AllowInvoice) && getState().receiptState.receipt.shouldinvoice) ||
                        (!paymentMethod.ShouldInvoice && !getState().receiptState.receipt.shouldinvoice)) {
                            itemList.push({
                                Description: paymentMethod.Description,
                                ItemId: paymentMethod.PaymentId
                            })
                        }
                    }
                    else {
                       if ((((paymentMethod.ShouldInvoice || paymentMethod.AllowInvoice) && getState().receiptState.receipt.shouldinvoice) || !paymentMethod.ShouldInvoice) &&
                            ((paymentMethod.AfterPay && getState().receiptState.receipt.customer.allowAfterPay) || !paymentMethod.AfterPay)) {
                            itemList.push({
                                Description: paymentMethod.Description,
                                ItemId: paymentMethod.PaymentId
                            })
                        }
                    }
                })

                dispatch(generalActions.setSelectModal(itemList, true, dispatch(dataActions.getTranslation(resource.SELECT_PAYMENT_METHOD)), continuePayment, []));
            }
            else {
                if (!getState().generalState.paymentMethod.all[0].ShouldInvoice && getState().receiptState.receipt.shouldinvoice) {
                    msg = dispatch(dataActions.getTranslation(resource.NO_PAYMENTMETHODS));
                }
                else {
                    dispatch(continuePayment(getState().generalState.paymentMethod.all[0].PaymentId));
                }
            }
        }

        if (msg !== '') {
            dispatch(generalActions.setMessageModal(true, msg));
            return;
        }
    }
}

export function continuePayment(paymentId, payAmount = -1, paymentChangeId = -1) {
    return (dispatch, getState) => {

        if (paymentId === 0) {
            return;
        }

        if (paymentId <= 0) {
            dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_PAYMENT_METHOD_SELECTED))));
            return;
        }

        //Get payment
        const payment = dispatch(dataActions.getPayment(paymentId));

        if (payment == null) {
            dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_PAYMENT_METHOD_SELECTED))));
            return;
        }

        //Get paymentamount
        let paymentAmount = dispatch(getPaymentAmount());

        if (payment.FixedAmount) {
            paymentAmount = payment.FixedAmount;
        }

        // Fast paymentamount
        if (payAmount > 0) {
            paymentAmount = payAmount;
        }

        //Get receiptAmount
        let receiptAmount = dispatch(receiptActions.getReceiptAmount());
        
        //Checken round amount
        if (payment !== null && payment.RoundAmount) {
            //Calculate rounded amount
            let paymentAmountRounded = (Math.round(paymentAmount * 20) / 20).toFixed(2);
            if (paymentAmount > receiptAmount) {
                paymentAmountRounded = paymentAmount - (receiptAmount - (Math.round(receiptAmount * 20) / 20)).toFixed(2);
            }

            const receiptAmountRounded = (Math.round(receiptAmount * 20) / 20).toFixed(2);

            //Save rounded amount dif on receipt
            const roundedAmount = paymentAmount - paymentAmountRounded;

            const rlParam = rl.Get();
            rlParam.Text = dispatch(dataActions.getTranslation(resource.ROUNDING));
            rlParam.Price = roundedAmount.toFixed(2) * -1;
            rlParam.ItemId = payment.PaymentId;
            rlParam.LineType = types.PAYMENT_ROUNDED_LINE;
            rlParam.Quantity = 1;
            rlParam.Editable = false;

            dispatch(receiptActions.addReceiptline(rlParam));

            //Replace payment- and receiptamount with rounded amount
            paymentAmount = (paymentAmount > receiptAmount) ? paymentAmount : paymentAmountRounded;
            receiptAmount = receiptAmountRounded;
        }

        if (getState().generalState.licenses.blackbox && getState().generalState.hasBlackbox) {
            //If receipt is finished and blackbox is active check if at least one receiptprinter is working
            if (receiptAmount <= paymentAmount) {
                let printerActive = false;
                getState().generalState.devices.map(device => {
                    if (device.printertype === 100
                        && device.status === status.PRINTER_OK) {
                        printerActive = true;
                    }
                    return '';
                });

                if (!printerActive) {
                    dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_WORKING_PRINTER))));
                    return;
                }
            }
        }

        if (payment !== null) {

            const paymentParams = {
                paymentId,
                paymentAmount,
                receiptAmount,
                paymentChangeId
            };

            if (payment.DeviceId && payment.DeviceId > 0 && paymentAmount !== 0) {  // paymentAmount !== 0 ensures that a customer is not prompted for payment
                // on a kiosk, if collecting a reservation and it has already been paid in full
                //If payment requires device, start payment on device
                dispatch(devicePayment(paymentId, paymentAmount, receiptAmount));
            } else if (payment.PaymentType === 300) { // Saldo
                //Accept negative amount for charging
                const inputquantitynegative = getState().receiptState.input.inputquantitynegative;
                if (inputquantitynegative) {
                    paymentAmount *= -1;
                }
                //If payment is saldo, do saldo check
                dispatch(saldoPayment(paymentParams));
            }
            else {
                //Finish payment
                dispatch(finishPayment(paymentParams));                
            }
        }
    }
}

export function devicePayment(paymentId, paymentAmount, receiptAmount) {
    return (dispatch, getState) => {
        dispatch(modalActions.setPaymentModal(true));
        const payment = dispatch(dataActions.getPayment(paymentId));
        if (payment.WaitForInput &&
            getState().modalState.paymentModal.cardinserted) {
            dispatch(startPaymentDevice(paymentId, paymentAmount, receiptAmount));
        } else if (!payment.WaitForInput) {
            dispatch(startPaymentDevice(paymentId, paymentAmount, receiptAmount));
        } else {
            dispatch(receiptActions.setPaymentDevice(paymentId, paymentAmount, receiptAmount, false, ''));
        }
    }
}

export function startPaymentDevice(paymentId, paymentAmount, receiptAmount) {
    return (dispatch, getState) => {
        const payment = dispatch(dataActions.getPayment(paymentId));
        const paymentParams = {
            PosId: getState().generalState.posId,
            Issuer: getState().generalState.posDescription,
            DeviceId: payment.DeviceId,
            CardName: getState().receiptState.receipt.cardname,
            ReceiptNumber: getState().receiptState.receipt.receiptnumber,
            Amount: paymentAmount,
            PosDeviceGuid: getState().generalState.uniqueid,
            PaymentId: payment.PaymentId
        }

        fetch(general.API_URL_STARTPAYMENT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(paymentParams)
        }).then(response => response.json())
            .then(json => {
                if (json) {
                    dispatch(receiptActions.setPaymentDevice(paymentId, paymentAmount, receiptAmount, true, ''));
                }
            });
    }
}

export function saldoPayment(paymentParams, exceedNegativeSaldo = false) {
    return (dispatch, getState) => {
        const customerId = getState().receiptState.receipt.customer.customerid;

        //Make api call to do payment
        const data = {
            PosId: getState().generalState.posId,
            CustomerId: customerId,
            Amount: paymentParams.paymentAmount,
            PosDeviceGuid: getState().generalState.uniqueid,
            ExceedNegativeSaldo: exceedNegativeSaldo
        }

        fetch(general.API_URL_SALDOPAYMENT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(json => {
                if (json.Success) {
                    dispatch(receiptActions.setPaymentDevice(0, 0, 0, false, '', json.OldSaldo, json.NewSaldo));
                    paymentParams.customerId = customerId;
                    paymentParams.transactionLogId = json.TransactionId;

                    dispatch(finishPayment(paymentParams));
                } else {
                    if (json.ErrCode === 100 && dispatch(hasRight(right.POS_EXCEED_NEGATIVE_SALDO, false))) {
                        dispatch(generalActions.setConfirmModal(dispatch(dataActions.getTranslation(resource.NEGATIVE_SALDO_MESSAGE)), saldoPayment, null, [paymentParams, true], null));
                    }
                    else {
                        dispatch(generalActions.setMessageModal(true, json.ErrMsg))
                    }
                }
            });
    }
}

export function finishPayment(paymentParams) { //paymentId, paymentAmount, receiptAmount, customerId, transactionLogId) {
    return (dispatch, getState) => {
        //Get payment
        const payment = dispatch(dataActions.getPayment(paymentParams.paymentId));
        
        //Open drawer
        if (payment.OpenDrawer && dispatch(hasRight(right.POS_DRAWER, false))) {
            dispatch(receiptActions.openDrawer(false));
        }

        const rlParam = rl.Get();
        rlParam.Text = payment.Description;
        rlParam.Price = paymentParams.paymentAmount * -1;
        rlParam.ItemId = payment.PaymentId;
        rlParam.LineType = types.PAYMENT_LINE;
        rlParam.Quantity = 1;
        rlParam.Editable = false;

        const rlParamOptional = rl.GetOptional();
        if (paymentParams.customerId !== undefined
            && paymentParams.transactionLogId !== undefined) {
            rlParamOptional.CustomerId = paymentParams.customerId;
            rlParamOptional.TransactionLogId = paymentParams.transactionLogId;
        }
        if (paymentParams.paymentDeviceParam) {
            rlParamOptional.BrandName = paymentParams.paymentDeviceParam.brandName;
            rlParamOptional.ClientTicket = paymentParams.paymentDeviceParam.clientTicket;
        }

        dispatch(receiptActions.addReceiptLineWithOptionalParams(rlParam, rlParamOptional));
    
        if (paymentParams.receiptAmount - paymentParams.paymentAmount < 0) {
            if (getState().generalState.paymentMethod.all.length > 1) {
                let defaultChangePaymentId; 

                // A fastpayment function button can have a default change paymenttype.
                if (paymentParams.paymentChangeId && paymentParams.paymentChangeId > 0){
                    defaultChangePaymentId = paymentParams.paymentChangeId;
                } else if (getState().receiptState.receipt.defaultChangeId > 0) {
                    defaultChangePaymentId = getState().receiptState.receipt.defaultChangeId;
                    // Clear because we don't need it anymore
                    dispatch(receiptActions.setTemporaryDefaultChangeId(0));
                } else {
                    for (let i = 0; i < getState().generalState.paymentMethod.all.length; i++) {
                        const payment = getState().generalState.paymentMethod.all[i];
    
                        if (getState().generalState.defaultChangePaymentId > 0) {
                            if (payment.PaymentId === getState().generalState.defaultChangePaymentId) {
                                defaultChangePaymentId = payment.PaymentId;
                                break;
                            }
                        }
                        else {
                            if (payment.DefaultChange) {
                                defaultChangePaymentId = payment.PaymentId;
                                break;
                            }
                        }
                    }
                }

                if (defaultChangePaymentId) {
                    dispatch(finishPaymentWithChange(defaultChangePaymentId, '', rlParam, paymentParams.receiptAmount, paymentParams.paymentAmount));
                } else {
                    const itemList = [];
                    const disablePaymentsWithInvoice =  getState().generalState.systemSettings[systemSetting.DISABLE_PAYMENTS_WITH_INVOICE];
                    getState().generalState.paymentMethod.all.forEach(paymentMethod => {
                        if (!disablePaymentsWithInvoice) {
                            if (((paymentMethod.ShouldInvoice && getState().receiptState.receipt.shouldinvoice) || !paymentMethod.ShouldInvoice) &&
                                ((paymentMethod.AfterPay && getState().receiptState.receipt.customer.allowAfterPay) || !paymentMethod.AfterPay)) {
                                itemList.push({
                                    Description: paymentMethod.Description,
                                    ItemId: paymentMethod.PaymentId
                                });
                            }
                        }
                        else {
                            if ((paymentMethod.ShouldInvoice && getState().receiptState.receipt.shouldinvoice) ||
                            (!paymentMethod.ShouldInvoice && !getState().receiptState.receipt.shouldinvoice)) {
                                itemList.push({
                                    Description: paymentMethod.Description,
                                    ItemId: paymentMethod.PaymentId
                                });
                            }
                        }
                    });

                    dispatch(generalActions.setSelectModal(itemList,
                        true,
                        `${dispatch(dataActions.getTranslation(resource.SELECT_PAYMENT_METHOD))} ${dispatch(dataActions.getTranslation(resource.CHANGE))}`,
                        finishPaymentWithChange,
                        [rlParam, paymentParams.receiptAmount, paymentParams.paymentAmount],
                        false));
                }
            }
            else {
                let paymentId = getState().generalState.paymentMethod.all[0].PaymentId;

                if (getState().generalState.defaultChangePaymentId > 0) {
                    paymentId = getState().generalState.defaultChangePaymentId;
                }

                dispatch(finishPaymentWithChange(paymentId, '', rlParam, paymentParams.receiptAmount, paymentParams.paymentAmount));
            }
        }
        else {
            dispatch(finishPaymentWithChange(0, '', rlParam, paymentParams.receiptAmount, paymentParams.paymentAmount));
        }
    }
}

export function finishPaymentWithChange(changePaymentId, changePaymentDescription, rlParam, receiptAmount, paymentAmount) {
    return (dispatch, getState) => {
        let change = 0;
        if (changePaymentId > 0) {
            if (receiptAmount - paymentAmount < 0) {

                const payment = dispatch(dataActions.getPayment(changePaymentId));
                if (payment !== null) {
                    // Create change line
                    change = paymentAmount - receiptAmount
                    rlParam.Price = change;
                    rlParam.Text = payment.Description;
                    rlParam.ItemId = changePaymentId;

                    if (payment.PaymentType === 300) { //Saldo 
                        const customerId = getState().receiptState.receipt.customer.customerid;

                        //Make api call to do payment
                        const paymentParams = {
                            PosId: getState().generalState.posId,
                            CustomerId: customerId,
                            Amount: change * -1,
                            PosDeviceGuid: getState().generalState.uniqueid
                        }

                        fetch(general.API_URL_SALDOPAYMENT, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(paymentParams)
                        })
                            .then(response => response.json())
                            .then(json => {
                                if (json.Success) {
                                    dispatch(receiptActions.setPaymentDevice(0, 0, 0, false, '', json.OldSaldo, json.NewSaldo));

                                    const rlParamOptional = rl.GetOptional();
                                    rlParamOptional.CustomerId = customerId;
                                    rlParamOptional.TransactionLogId = json.TransactionId;

                                    dispatch(receiptActions.addReceiptline(rlParam, rlParamOptional));
                                    dispatch(paymentSuccessfull(receiptAmount, paymentAmount, change));
                                } else {
                                    dispatch(generalActions.setMessageModal(true, json.ErrMsg));
                                }
                            });
                    } else {
                        dispatch(receiptActions.addReceiptline(rlParam));
                         dispatch(paymentSuccessfull(receiptAmount, paymentAmount, change));
                    }
                }
            }
        } else {
            dispatch(paymentSuccessfull(receiptAmount, paymentAmount, change));
        }
    }
}

export function paymentSuccessfull(receiptAmount, paymentAmount, change) {
    return (dispatch, getState) => {
        const state = getState();

        if (receiptAmount - paymentAmount <= 0) {
            // Receipt is finished
            dispatch(receiptActions.saveReceipt());
        
            if (change !== 0 && state.generalState.posType === types.POSTYPE_NORMAL) {
                const changeAmount = change.toFixed(2).replace('.', ',');
                const description = `${dispatch(dataActions.getTranslation(resource.CHANGE))}: ${changeAmount}`;

                const pos = dispatch(dataActions.getPos(state.generalState.posId));
                if (pos !== null && pos.GraphicalRefund) {
                    dispatch(modalActions.setChangeModal(true, change));
                }
                else {
                    dispatch(generalActions.setMessageModal(true, description));
                }
            }

            //When receipt is finished then reset pricelist
            dispatch(receiptActions.setPriceList(getState().generalState.defaultPricelistId));
           
            //When payment is successfull then launch to default page
            if (getState().layoutState.defaultpage > 0) {
                dispatch(setGroup(getState().layoutState.defaultpage));
            }
        }

        dispatch(receiptActions.setInputQuantity('0'));
        dispatch(receiptActions.setPaymentDevice(0, 0, 0, false, ''));
        dispatch(modalActions.setPaymentModalCardInserted(false));
    }
}

export function abortPayment(paymentId) {
    return (dispatch, getState) => {    
        const receipt = getState().receiptState.receipt;
        const cleanUp = () => {
            dispatch(modalActions.setPaymentModal(false));
            if (receipt.cancelOnAbort) {
                dispatch(receiptActions.emptyReceipt(false));
            }
        };

        if (receipt.paymentdevice.busy) {
            var payment = dispatch(dataActions.getPayment(paymentId));
            if (payment !== null) {
                const paymentParams = {
                    PosId: getState().generalState.posId,
                    DeviceId: payment.DeviceId,
                    Amount: 0,
                    PosDeviceGuid: getState().generalState.uniqueid
                }

                fetch(general.API_URL_ABORTPAYMENT, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(paymentParams)
                })
                .then(response => response.json())
                .then(json => {
                    if (json) {
                        dispatch(receiptActions.setPaymentDevice(0, 0, 0, false, ''));
                    }
                });
            }
        }

        dispatch(receiptActions.setTemporaryDefaultChangeId(0));

        cleanUp();
    }
}

export function getPaymentAmount() {
    return function (dispatch, getState) {
        const state = getState();

        let paymentAmount = 0;
        if (state.receiptState.input.inputquantity === '0') {
            paymentAmount = dispatch(receiptActions.getReceiptAmount());
        } else {
            paymentAmount = parseFloat(state.receiptState.input.inputquantity);
        }

        return paymentAmount;
    }
}



// WEBPACK FOOTER //
// src/functions/PaymentFunctions.js